import { useDispatch, useSelector } from 'react-redux';
import { selectFlattenAreaState } from 'store/slices/TreeSlice/selector';
import { setFlattenHeight } from 'store/slices/TreeSlice';
import { convertFeetToMetric, convertMetricToFeet } from '../../util';
import TreeSliderInputField from 'components/Tree/TreeSliderInputField';
import { TreeFieldItem } from 'components/Tree/styles';

const SLIDER_MAX_HEIGHT = 328.1; // 100 m in feet
const SLIDER_MIN_HEIGHT = -164.0; // -50 m in feet
const INPUT_MAX_HEIGHT = 328.1; // 100 m in feet
const INPUT_MIN_HEIGHT = -164.0; // -50 m in feet
const STEP = 1;

type Props = {
	isActive?: boolean;
	onActivate?: () => void;
	disabled?: boolean;
};

export default function FlattenAreaHeightField({ isActive, onActivate, disabled }: Props) {
	const dispatch = useDispatch();
	const { activePolygon } = useSelector(selectFlattenAreaState);

	if (!activePolygon) return null;

	const value = convertMetricToFeet(activePolygon.height ?? 0);

	const updateValue = (next: number) => {
		const normalized = Number.isFinite(next)
			? Math.max(INPUT_MIN_HEIGHT, Math.min(INPUT_MAX_HEIGHT, next))
			: 0;
		dispatch(setFlattenHeight({ id: activePolygon.id, height: convertFeetToMetric(normalized, 'm', 6) }));
	};

	return (
		<TreeFieldItem>
			<TreeSliderInputField
				id="flatten-area-height"
				label="Height"
				value={value}
				min={INPUT_MIN_HEIGHT}
				max={INPUT_MAX_HEIGHT}
				sliderMax={SLIDER_MAX_HEIGHT}
				sliderMin={SLIDER_MIN_HEIGHT}
				step={STEP}
				unit="ft"
				isActive={!!isActive}
				onActivate={onActivate}
				onInputChange={updateValue}
				showSlider={true}
				disabled={disabled}
			/>
		</TreeFieldItem>
	);
}
